import { useQuery } from 'react-query';
import {
  getBettieEnergies,
  type GetBettieEnergiesResponse
} from '../../services/bettieEnergiesService';

export function useGetBettieEnergies() {
  return useQuery<GetBettieEnergiesResponse, Error>(['bettieEnergies'], () => getBettieEnergies());
}
